import { Printer } from 'lucide-react';
import { useCallback, useState } from 'react';
import { Button, Dialog, ErrorState, LoadingState } from '@/components/ui';
import { useReceipt } from '@/features/billing/api';
import { ReceiptBody } from './ReceiptBody';
import { ReceiptPrintSheet } from './ReceiptPrintSheet';

/** Printable receipt of a closed bill (IC/passport shown as the last 4 only). */
export function ReceiptDialog({
  billId,
  onClose,
}: {
  billId: string;
  onClose: () => void;
}) {
  const { data: r, isLoading, error, refetch } = useReceipt(billId);
  const [printing, setPrinting] = useState(false);
  const donePrinting = useCallback(() => setPrinting(false), []);
  return (
    <Dialog
      open
      variant="modal"
      title={r ? `Receipt ${r.receiptNumber}` : 'Receipt'}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Close</Button>
          <Button
            variant="primary"
            icon={<Printer size={16} />}
            disabled={!r}
            onClick={() => setPrinting(true)}
          >
            Print
          </Button>
        </>
      }
    >
      {isLoading ? (
        <LoadingState />
      ) : error || !r ? (
        <ErrorState error={error} onRetry={() => void refetch()} />
      ) : (
        <ReceiptBody r={r} />
      )}
      {printing && r && <ReceiptPrintSheet receipt={r} onDone={donePrinting} />}
    </Dialog>
  );
}
